/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Source_ScheduledInputs */



/**
* | output |
* | --- |
* | "Scheduled" |
*
* @param {Agent_Run_Source_ScheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_source_scheduled = /** @type {((inputs?: Agent_Run_Source_ScheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Source_ScheduledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplant")
	return /** @type {LocalizedString} */ ("Scheduled")
});